













































import Vue from 'vue';
import {API, getDesserts} from '@/api';
import { mapActions } from 'vuex';
import AgregarCuentaContable from '@/components/contables/AgregarCuentaContable.vue';

export default Vue.extend({
  components: { AgregarCuentaContable },
  data: () => ({
    singleSelect: false,
    row: {},
    selected: [],
    headers: [
      { text: 'Tipo', value: 'tipo' },
      { text: 'Descripción', value: 'descripcion' },
      { text: 'Numero de Cuenta', value: 'numCuenta' },
    ],
    total: 0,
    Cuentas: [],
    loading: true,
    options: {},
    dialog: false,
    readonly: true,
  }),
/*  mounted() {
  },*/
  methods: {
    ...mapActions(['getContableList']),
    open(event) {
      console.log('Current:', event);
      this.Concepto = event;
      this.dialog = true;
      this.readonly = true;
    },
    rowSelected(event) {
      this.open(event);
    },
    async loadData() {
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        this.loading = true;
        const result = await this.$store.dispatch('getContableList', {admin, condo, options: this.options});
        console.debug('getContableList result: %o', result);
        this.total = result.totalElements;
        this.Cuentas = result.content;
        console.log('Cuentas contables: %o', this.Cuentas);
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
  },
});
